import { createContext, useContext, useState } from "react";
import { ConfirmationModal } from "../components/ModalComponents";



const ModalContext = createContext()


export const ModalController = ( props ) => {

    const [modalState, setModalState] = useState({
        isVisible: false,
        message: '',
        resolve: null,
    })

    const requestConfirmation = (message) => {
        return new Promise((resolve) => {
            setModalState({ isVisible: true, message, resolve })
        })
    }

    const closeModal = (confirmed) => {
        modalState.resolve(confirmed)
        setModalState({ isVisible: false, message: '', resolve: null })
    }

    return (
        <ModalContext.Provider value={{
            requestConfirmation
        }}>
            {props.children}
            <ConfirmationModal
                isVisible={modalState.isVisible}
                message={modalState.message}
                onClose={() => closeModal(false)}
                onConfirm={() => closeModal(true)}
            />
        </ModalContext.Provider>
    )
}

export const useConfirm = () => {
    const { requestConfirmation } = useContext(ModalContext)
    return requestConfirmation
}